import { lazy } from 'react';

import AuthGuard from 'utils/route-guard/AuthGuard';
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

const ListArcsaMuestraProductosView = Loadable(lazy(() => import('views/administrator/ArcsaView/ListMuestraProductosView')));
const NewArcsaMuestraProductosView = Loadable(lazy(() => import('views/administrator/ArcsaView/NewMuestraProductosView')));
const ListArcsaTiposDefectosView = Loadable(lazy(() => import('views/administrator/ArcsaView/ListTiposDefectosView')));
const NewArcsaTiposDefectosView = Loadable(lazy(() => import('views/administrator/ArcsaView/NewTiposDefectosView')));
const ListArcsaNivelInspeccionView = Loadable(lazy(() => import('views/administrator/ArcsaView/ListNivelInspeccionView')));
const NewArcsaNivelInspeccionView = Loadable(lazy(() => import('views/administrator/ArcsaView/NewNivelInspeccionView')));
const ConfiguracionReporteView = Loadable(lazy(() => import('views/administrator/ArcsaView/ConfiguracionReporteView')));

const ArcsaRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/user/list-arcsa-muestra-productos',
            element: <ListArcsaMuestraProductosView />
        },
        {
            path: '/user/new-arcsa-muestra-productos/:id_arcsa',
            element: <NewArcsaMuestraProductosView />
        },
        {
            path: '/user/list-arcsa-tipos-defectos',
            element: <ListArcsaTiposDefectosView />
        },
        {
            path: '/user/new-arcsa-tipos-defectos/:id_arcsa',
            element: <NewArcsaTiposDefectosView />
        },
        {
            path: '/user/list-arcsa-nivel-inspeccion',
            element: <ListArcsaNivelInspeccionView />
        },
        {
            path: '/user/new-arcsa-nivel-inspeccion/:id_arcsa',
            element: <NewArcsaNivelInspeccionView />
        },
        {
            path: '/user/arcsa-configuracion-reporte',
            element: <ConfiguracionReporteView />
        },
    ]
};

export default ArcsaRoutes;
